/**
 * @classdesc
 * Abstrakte Wrapperklasse für WMTS Capabilities-Dokumente.
 *
 * @class
 * @extends Object
 * @memberof gc.gis.format
 * @author Christian Schmidt <c.schmidt@brain-scc.de>
 * @param {T} capabilities gewrappte Capabilities-Instanz
 */
gc.gis.format.GCWmtsCapabilities = function (capabilities)
{
    gc.gis.GCWrappable.call(this);

    this._impl = capabilities;

    this.version = undefined;
    this.title = undefined;
    this.abstract = undefined;
    this.accessConstraints = undefined;
    this.fees = undefined;
    /**
     * @type {gc.gis.format.GCWmtsCapabilitiesLayer[]}
     */
    this.layers = [];
};
gc.gis.format.GCWmtsCapabilities.prototype = Object.create(gc.gis.GCWrappable);

gc.gis.format.GCWmtsCapabilities.prototype.getImpl = function()
{
    return this._impl;
};

/**
 * Liefert die Anzahl der Layer.
 * @public
 * @return {int}
 */
gc.gis.format.GCWmtsCapabilities.prototype.numLayers = function()
{
    return this._layers.length;
}

/**
 * Liefert einen Layer anhand seines Identifiers.
 * @public
 * @param {string} identifier
 * @return {gc.gis.format.GCWmtsCapabilitiesLayer|null}
 */
gc.gis.format.GCWmtsCapabilities.prototype.getLayerByIdentifier = function(identifier)
{
    for (let i = 0, ii = this.layers.length; i < ii; i++)
    {
        if (identifier === this.layers[i].identifier)
        {
            return this.layers[i];
        }
    }

    return null;
}